import type { Tier } from '@/hooks/use-pricing';
import type { DailyEarning, CollectorSummary } from '../types';

export function getBaseEarnings(s: CollectorSummary): number {
  return s.base_earnings ?? 0;
}

export function getAvgLeadsPerDay(daily: DailyEarning[]): number {
  if (!daily.length) return 0;
  const total = daily.reduce((sum, d) => sum + d.lead_count, 0);
  return total / daily.length;
}

export function getCurrentTier(
  avgLeads: number,
  tiers: Tier[]
): Tier | undefined {
  const rounded = Math.round(avgLeads);
  return tiers.find(
    (t) => rounded >= t.min && (t.max === null || rounded <= t.max)
  );
}

const TIER_COLORS = [
  'text-text-tertiary',
  'text-brand-red/70',
  'text-brand-red',
];

export function getTierColor(creatorCount: number, tiers: Tier[]): string {
  const idx = tiers.findIndex(
    (t) => creatorCount >= t.min && (t.max === null || creatorCount <= t.max)
  );
  return TIER_COLORS[Math.min(idx, TIER_COLORS.length - 1)] ?? TIER_COLORS[0]!;
}

export function getTierFill(creatorCount: number, tiers: Tier[]): string {
  const idx = tiers.findIndex(
    (t) => creatorCount >= t.min && (t.max === null || creatorCount <= t.max)
  );
  const fills = ['#cc3636', '#ff4444', '#ff4444'];
  return fills[Math.min(idx, fills.length - 1)] ?? fills[0]!;
}
